<template>
  <v-card dark class="primary darken-1" height="327" :min-width="minWidth" :width="width"
    style="border-radius: 5px; overflow-y: auto">
    <v-expand-transition>
      <div v-if="ice" class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal">
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon large color="secondary lighten-1" @click="toggleIce">mdi-arrow-left-circle</v-icon>
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1">$ice</v-icon>
            </v-col>
          </v-row>
          <br />
          {{ iceText }}
        </v-card-text>
      </div>
      <div v-if="table" class="d-flex transition-fast-in-fast-out primary darken-1 v-card--reveal">
        <v-card-text class="secondary--text text--lighten-1 text-justify">
          <v-row>
            <v-col cols="6">
              <v-icon large color="secondary lighten-1" @click="toggleTable">mdi-arrow-left-circle</v-icon>
            </v-col>
            <v-spacer />
            <v-col cols="6" align-self="end" align="end">
              <v-icon large color="secondary lighten-1">$ice</v-icon>
            </v-col>
          </v-row>
          <br />
          <v-row dense>
            <v-col cols="6" md="8" lg="7" xl="8"><span style="color: transparent">.</span></v-col>
            <v-col cols="6" md="4" lg="5" xl="4" align-self="end" align="end">
              <v-select v-model="option" :items="options" item-text="text" return-object dense hide-details attach dark
                color="secondary lighten-1" item-color="secondary lighten-1" @change="changeItemTable"></v-select>
            </v-col>
          </v-row>
          <br />
          <v-col cols="12" v-for="(item, i) in items" :key="i" class="pa-0">
            <div class="pa-0 d-flex" :style="`background: ${item.color}`" sty>
              <v-row>
                <v-col cols="5" align="start" class="ml-2">
                  <span>{{ item.year }}</span>
                </v-col>
                <v-spacer />
                <v-col cols="5" align="end" class="mr-2">
                  <span>{{ item.value }}</span>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-card-text>
      </div>
    </v-expand-transition>
    <div v-if="!ice && !table">
      <v-card-subtitle class="white--text text--white">
        <span class="textDate"><v-icon small>restore</v-icon> atualizado em</span><br />
        <span class="textDate" v-if="iceData.length > 0"> {{ iceData[0].year }}</span>
      </v-card-subtitle>
      <v-card-title>
        <v-icon class="ml-n1" color="secondary lighten-1" large>
          $ice
        </v-icon>
      </v-card-title>
      <v-card-subtitle class="white--text text--white">
        <v-row dense>
          <v-col cols="5">
            <strong class="textTitle">ICE</strong>
            <v-tooltip right color="#1A232F">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-1" color="secondary lighten-1" v-bind="attrs" v-on="on" @click="toggleIce">
                  help_outline
                </v-icon>
              </template>
              <span>Clique para informações</span>
            </v-tooltip>
          </v-col>
          <v-col cols="6">
            <div @click="toggleTable" style="cursor: pointer;" v-if="iceData.length > 0">
              <span class="secondary--text text--lighten-1 textTable">Dados tabulares <strong>></strong></span>
            </div>

          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text class="white--text text--white">
        <v-row dense v-if="iceData.length == 0">
          <v-col cols="12" v-if="iceFirstAccess">
            <span class="secondary&#45;&#45;text text&#45;&#45;lighten-1 textNoData">
              Para ter acesso a um índice selecione uma SIA.
            </span>
          </v-col>

          <v-col cols="12" v-else>
            <span class="secondary&#45;&#45;text text&#45;&#45;lighten-1 textNoData">
              Sem dados para SIA.
            </span>
          </v-col>
        </v-row>
        <div v-else>
          <v-row v-for="(item, index) in iceData[0].values" :key="index" dense>
            <v-col cols="6">
              <span class="textItem">{{ changeFirstWordToCapital(item.tipo) }}</span>
            </v-col>
            <v-col cols="6">
              <v-icon class="mt-n1" :color="getColorIce(item.class).hexa">fiber_manual_record</v-icon><strong
                class="textItemValue">{{
                  new Intl.NumberFormat("pt-BR").format(item.valor) }}</strong>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'CardIce',
  props: {
    minWidth: {
      required: false,
    },
    width: {
      required: false,
    },
  },
  data() {
    return {
      ice: false,
      table: false,
      option: {},
      options: [
        { text: 'Total', value: 0 },
        { text: 'Físico-químico', value: 1 },
        { text: 'Metais', value: 2 },
        { text: 'Tóxicos', value: 3 },
      ],

      items: [],
      iceText:
        'O ICE (Índice de Conformidade de Enquadramento) foi originalmente proposto pelo Canadian Council of Ministers of the Environment (CCME, 2001). Este índice analisa tanto a frequência da não conformidade de um conjunto de parâmetros, bem como a magnitude da não conformidade. Como exemplos de aplicações tem-se no Peru (ICARHS) e Brasil (Agência Nacional de Águas).\n' +
        'O ICE analisa três aspectos:\n' +
        'Abrangência: número de parâmetros de qualidade de água que apresentaram desconformidade com o padrão do enquadramento;\n' +
        'Frequência: porcentagem de vezes em que a variável esteve em desconformidade com o padrão do enquadramento;\n' +
        'Amplitude: diferença entre o valor observado e o valor desejado, no caso, limite do enquadramento.\n' +
        'O ICE é calculado para todos os pontos que são monitorados e para todos os parâmetros analisados dos quais existe uma concentração limite ou da CONAMA 387/2005 (Classe II, águas doces) ou da portaria GC MS 888/2021. O ICE foi dividido em quatro tipos, seguindo também a categorização do TECPAR, sendo Tipo I (Físico-químico), Tipo II (Metais), Tipo III (Tóxicos) e os três tipos juntos, contemplando todos os parâmetros com concentrações limites.',
    };
  },
  created() {
    this.option = { text: 'Total', value: 0 };
    this.changeItemTable();
  },

  beforeDestroy() {
    this.$store.commit('setIceFirstAccess', true)
    this.$store.commit('setIndicatorIce', [])
  },

  computed: {
    ...mapGetters(["iceData", "iceFirstAccess"]),
  },

  methods: {
    changeItemTable() {
      if (this.iceData.length > 0) {
        if (this.option.value === 0) {
          this.getItemsForTable('total')
          return
        }

        if (this.option.value === 1) {
          this.getItemsForTable('físio-químico')
          return
        }
        if (this.option.value === 2) {
          this.getItemsForTable('metais')
          return
        }
        if (this.option.value === 3) {
          this.getItemsForTable('tóxico')
          return
        }
      }
    },
    toggleIce() {
      this.ice = !this.ice;
    },
    toggleTable() {
      this.table = !this.table;
    },

    getItemsForTable(type) {
      this.items = []
      this.iceData.forEach(el => {
        el.values.forEach((item) => {
          if (item.tipo == type) {
            this.items.push({
              color: this.getColorIce(item.class).rgb,
              year: el.year,
              value: item.valor ? new Intl.NumberFormat("pt-BR").format(item.valor) : "Sem dados"
            })
          }
        })
      });
    },
    normalizeStr(str) {
      return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    getColorIce(s) {
      if (s != null) {
        const status = this.normalizeStr(s);
        if (status.startsWith("boa") || status.startsWith("bom")) {
          return {
            hexa: '#219653',
            rgb: 'rgba(182, 206, 141, 0.3)'
          }
        }
        if (status.startsWith("regular")) {
          return {
            hexa: '#F2D965',
            rgb: 'rgba(242, 201, 76, 0.3)'
          }
        }
        if (status.startsWith("ruim")) {
          return {
            hexa: '#F2994A',
            rgb: 'rgba(242, 153, 74, 0.3)'
          }
        }
        if (status.startsWith("pessim")) {
          return {
            hexa: '#EB5757',
            rgb: 'rgba(235, 87, 87, 0.3)'
          }
        }
        if (status.startsWith("otim")) {
          return {
            hexa: '#2F80ED',
            rgb: 'rgba(47, 128, 237, 0.3)'
          }
        }
      }

      return {
        hexa: '#D9D9D9',
        rgb: 'rgba(217, 217, 217, 0.3)'
      }

    },

    changeFirstWordToCapital(word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }
  }
}
</script>

<style scoped>
.textDate {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}

.textTitle {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
}

.textItem {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
}

.textItemValue {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
}

.textTable {
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
}

.textNoData {
  color: #95A1EC;
  font-size: 14px;
  font-family: Roboto;
  font-style: italic;
  font-weight: 300;
  line-height: 20px;
}

::-webkit-scrollbar {
  width: 7px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: darkgrey;
}

::-webkit-scrollbar-thumb:hover {
  background: grey;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot:before {
  border: none !important;
}

::v-deep .v-text-field>.v-input__control>.v-input__slot:after {
  border: none !important;
}

::v-deep .v-icon.notranslate.material-icons.theme--dark {
  color: var(--v-secondary-lighten1);
}

::v-deep .v-select__selection.v-select__selection--comma {
  color: var(--v-secondary-lighten1);
}
</style>
